import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Spinner } from "../../../../assets/spinner.svg";
import styles from "../Courier/EnableMerchant.module.css";
import {
  approveTransfer,
  rejectTransfer,
} from "../../../financials/financialActions";

class ApproveTransfer extends Component {
  render() {
    const {
      transfer,
      approveTransfer,
      rejectTransfer,
      loading,
      closePanel,
    } = this.props;

    const onApprove = () => {
      approveTransfer(transfer);
      closePanel();
    };

    const onReject = () => {
      rejectTransfer(transfer, "");
      closePanel();
    };

    return (
      <div style={{ display: "inline-block" }}>
        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              fontSize: "10px",
              textTransform: "uppercase",
              color: "#666",
              marginBottom: "4px",
            }}
          >
            Reason for Transfer
          </div>
          <div style={{ fontSize: "14px", fontWeight: "500" }}>
            {transfer.reason}
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
          type="button"
          className={styles.btn}
          onClick={onApprove}
          disabled={loading}
        >
          {loading ? (
            <Spinner
              style={{
                width: "20px",
                height: "20px",
                verticalAlign: "middle",
              }}
            />
          ) : (
            <span>Approve</span>
          )}
        </button>

        <button
          type="button"
          className={styles.btn}
          onClick={onReject}
          disabled={loading}
          style={{ backgroundColor: "red" }}
        >
          {loading ? (
            <Spinner
              style={{
                width: "20px",
                height: "20px",
                verticalAlign: "middle",
              }}
            />
          ) : (
            <span>Reject</span>
          )}
        </button>
        </div>
      </div>
    );
  }
}

const actions = {
  approveTransfer,
  rejectTransfer,
};

const mapStateToProps = (state) => ({
  loading: state.async.loading,
});

export default connect(mapStateToProps, actions)(ApproveTransfer);
